import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RealEstateProjectActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/RealEstateProject/RealEstateProjectBrowser")
	}

	render() {
		return (
			<Activity 
				name="RealEstateProject"
				RenderedComponent={this.RenderedComponent}
				context="RealEstateProject"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RealEstateProjectActivity)
